const rootActionPath = 'core/homeSignInNag';

export const HOME_SIGN_IN_NAG_OPEN_LARGE_WITH_ANIMATION = `${rootActionPath}/OPEN_LARGE_NAG_WITH_ANIMATION`;
export const HOME_SIGN_IN_NAG_SHOW_TERMS = `${rootActionPath}/OPEN_LARGE_NAG_SHOW_TERMS`;
export const HOME_SIGN_IN_NAG_CLOSE_LARGE_NAG_AND_OPEN_SMALL = `${rootActionPath}/CLOSE_LARGE_NAG_AND_OPEN_SMALL`;
